export function beforeSend(event) {
  const fetchError = event.exception.values.filter((e) => e.type == 'FetchError')
  if (fetchError.length) {
    const status = parseInt(fetchError[0].value.match(/: (\d{3})/)?.[1]) || null
    if (status < 500) {
      return null
    }
  }

  const frames = event.exception?.values?.[0]?.stacktrace?.frames || [];
  const isGtmError = frames.some(frame => frame.filename && (frame.filename.includes('googletagmanager.com') || frame.filename.includes('gtm.js')));

  if (isGtmError) {
    return null;
  }

  return event
}